module.exports = __webpack_public_path__ + "static/media/pizza_logo.e2e36eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/pizza_logo.png
// module id = 1124
// module chunks = 0